import { OneTimePayment, ScheduledPayment } from '../compensation/compensation-history/compensation-history-model';
import { Employment } from '../employment/employment-model';

export interface ScheduledPaymentsAndOpt {
	compensations: ScheduledPayment[],
	otp: OneTimePayment[],
}

export interface EmploymentCompensation {
	employment: Employment,
	compensations: ScheduledPaymentsAndOpt,
}

export interface EmploymentCompensationState {
	employmentCompensationLoaded: boolean;
	employmentCompensation: EmploymentCompensation[],
}

export enum EmploymentCompensationActions {
	SET_EMPLOYMENT_COMPENSATION = 'SET_EMPLOYMENT_COMPENSATION',
	CLEAR_EMPLOYMENT_COMPENSATION = 'CLEAR_EMPLOYMENT_COMPENSATION',
}